import Backbone from 'backbone'
import _ from 'lodash'
import GenericOverviewInfoDisplayHeader from 'scoreboard/components/overview-info/generic-overview-info-display-header'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import SendToOptions from 'scoreboard/components/send-to-options'
import constants from 'scoreboard/components/constants'
import i18n from 'scoreboard/components/i18n'
import metadata from 'scoreboard/components/metadata'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import appDisplay from 'scoreboard/components/app-display'
import conductor from 'scoreboard/components/conductor'
import globals from 'scoreboard/components/globals'
import permissions from 'scoreboard/components/permissions'
import ReportDatasetOverviewInfo from './report-dataset-overview-info'
import { isV6 } from 'scoreboard/components/version'

// the reports module heavily overrides the Backbone.Model.fetch in a way that
// isn't desirable here
var SimpleReport = Backbone.Model.extend({
	urlRoot: 'api/reports',
	section: 'reports'
})

var ReportsDisplayHeader = GenericOverviewInfoDisplayHeader.extend({

	initialize: function(options) {
		GenericOverviewInfoDisplayHeader.prototype.initialize.apply(this, arguments)

		//show/hide if the dataset calendar field changes or if the structure of the report changes
		this.listenTo(this.model, 'change:calendarFieldId change:filters change:structure', (prop, value) => {
			this.togglePeriodDisplay(this.model.showPeriodSelector())
		})
	},

	render: function() {
		GenericOverviewInfoDisplayHeader.prototype.render.apply(this, arguments)

		// #39658 always show info for dataset reports so the
		// chosen dataset is visible
		if (this.model.get('subtype') === 'dataset-report-designer'
			&& this.model.isNew()) {
			this.renderButtons()
			this.$('.open-alerts').addClass('is-not-displayed')
			this.$('.open-overview-info span')
				.css('border', 'none')
		}
		return this
	},

	_renderPeriodDisplay: function() {
		GenericOverviewInfoDisplayHeader.prototype._renderPeriodDisplay.apply(this, arguments)
		this.togglePeriodDisplay(_.invoke(this.model, 'showPeriodSelector'))	//initial display
	},

	redrawDisplay: function(newPeriodId) {
		this.trigger('change:period', newPeriodId)
	},

	overviewInfo: function() {
		var model = new SimpleReport({ id: this.model.id })
		let data = {
			relatedItems: true,
			templateInfo: true
		}
		if (_.result(this.model, 'periodSelector')) {
			data.currentCalendarId = globals.periodId
		}
		if (this.model.isNew()) {

			// There will only be an overview info button on a
			// new report if it's a dataset report
			appDisplay.dialog(this.getReportDatasetOverviewInfo(this.model))
			return
		}
		appDisplay.dialog(model.fetch({data}), function() {
			var report = new SimpleReport(model.get('form'))
			if (_.get(report.attributes, 'subtype') == 'dataset-report-designer') {
				return this.getReportDatasetOverviewInfo(report)
			}
			return new GenericOverviewInfo({ model: report })
		}.bind(this))
	},

	getReportDatasetOverviewInfo: function(model) {
		// Fill in source dataset info to display in the info dialog
		return new ReportDatasetOverviewInfo({
			model: _.extend({}, model, {
				datasetLabel: _.get(this.model.attributes, 'dataset.attributes.label')
			})
		})
	},

	styleAlertButton: function(hasAlerts) {
		GenericOverviewInfoDisplayHeader.prototype.styleAlertButton.apply(this, arguments)
		if (this.alertButton) {
			this.alertButton.find('.icon-menu').hide()
			this.alertButton
				.toggleClass('is-not-displayed', !permissions.bookmarks())
		}
	}

})

var reportHeader = {
	generate: function(subsection, model, resultsView) {

		var heading = model.isNew() && !model.get('label') ?
			i18n.get('common.create2', metadata.reports.createTypeCode) :
			model.get('label')

		// #9102 for new reports use the previous report as the id reference
		// the router is be smart enough to use the correct report model
		var tabsCtx = _.assign({
			section: constants.SECTION_REPORTS
		}, model.attributes)

		if (model.isNew()) {
			//#45783 use a dedicated url for new unsaved reports
			tabsCtx.id = 'new'
			if (isV6()) {
				tabsCtx.hideAlerts = true
				tabsCtx.hideInfo = true
				tabsCtx.hideAudit = true
			}
		} else {
			tabsCtx.id = model.get('id')
			if (_.isNil(tabsCtx.id)) {
				//when creating a new report on an empty org use special url to
				//handle routing so we don't get lost #9102
				tabsCtx.section = 'organizations'
				tabsCtx.id = globals.orgId + '/' + constants.SECTION_REPORTS + '/new'
			}
		}

		tabsCtx.overviewTabCode = 'common.view'

		// invoked by send-to-export.js
		const uiState = options => {
			// Not all reports may have state
			let state = _.invoke(resultsView, 'getState', options)
			if (options?.export) {
				return state
			} else {
				// #55491 for bookmarks and briefings, leave out the current
				// calendar id so that the report will use the default
				return _.omit(state, 'currentCalendarId')
			}
		}
		let sendToCtx = {
			section: constants.SECTION_REPORTS,
			type: model.get('type'),
			subtype: model.get('subtype'),
			uiState,
			// If unsaved don't load by Id, instead we need to load the persisted state
			exportURL: () => model.get('dirty') || model.isNew() ? 'reports' : undefined,
			domainId: () => !model.isNew() ? model.id : undefined
		}

		//if there was a server error, let's prevent exporting so we don't have
		//to deal with potentially messed up exports #46358
		let noServerError = _.isNil(model._xhrErr)
		let sendToOptions
		if (subsection !== 'edit' && noServerError) {
			if (model.get('subtype') === 'sql-console') {
				sendToCtx.csvDownloadFn = () => {
					return model.fetchCSV()
				}
			} else {
				sendToCtx.excelFn = resultsView.exportTable &&
					resultsView.exportTable.bind(resultsView, heading)
			}
			sendToOptions = model.isNew()
				? SendToOptions.exportServerOptions(sendToCtx)
				: SendToOptions.default(sendToCtx)

		}

		return new ReportsDisplayHeader({
			model: model,
			heading: heading,
			tabs: tabs(tabsCtx),
			section: constants.SECTION_REPORTS,
			subsection: subsection,
			sendToOptions: sendToOptions,
			bookmark: !model.isNew() && subsection !== 'edit',
			periods: _.result(model, 'periodSelector'),
			context: function() {
				return _.clone(this.model.attributes)
			},
			uiState,
			guard: false	//do not guard when changing periods
		})
	}
}

export default reportHeader

reportHeader.__filename__ = 'reports/report-header.js'
